import microuniversoApi from "app/api/microuniversoApi";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { Vendedor } from "app/types/Vendedor";
import { WindowMU } from "app/types/WindowMU";

declare var window: WindowMU

export async function adicionarVendedores(vendedores: Vendedor[]) {
    
    const resultado = await microuniversoApi.Orcamento.adicionarVendedores(store.getState().orcamento.IdentificadorOrcamento, vendedores)

    if (!("HasErrors" in resultado)) {
        store.dispatch(sobrescreverInformacoesAction({ Vendedores: resultado.Vendedores }))
    }
    return resultado;
}

export async function removerVendedores(vendedores: Vendedor[]) {

    const resultado = await microuniversoApi.Orcamento.removerVendedores(store.getState().orcamento.IdentificadorOrcamento, vendedores)

    if (!("HasErrors" in resultado)) {
        store.dispatch(sobrescreverInformacoesAction({ Vendedores: resultado.Vendedores }))
    }
    return resultado;
}